var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.contact.display)?_c('div',{staticClass:"cc-contact",domProps:{"innerHTML":_vm._s(_vm.contact.html)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }